import { Commit } from 'vuex';
import authApi from '@/data-provider/authentication';
import { UserState } from './types';

export const initialState: UserState = {
  id: 0,
  name: '',
  email: '',
  roles: [],
};

const user = {
  namespaced: true,
  state: initialState,
  getters: {
    getUserId: (state: UserState) => state.id,

    getUserName: (state: UserState) => state.name,

    getUserEmail: (state: UserState) => state.email,

    getUserRoles: (state: UserState) => state.roles,
  },
  mutations: {
    setUserId(state: UserState, userId: UserState['id']) {
      state.id = userId;
    },

    setUserName(state: UserState, name: UserState['name']) {
      state.name = name;
    },

    setUserEmail(state: UserState, email: UserState['email']) {
      state.email = email;
    },

    setUserRoles(state: UserState, roles: UserState['roles']) {
      state.roles = roles;
    },
  },
  actions: {
    getUserInfo({ commit }: { commit: Commit }) {
      return authApi.getUserInfo().then((response) => {
        if (response.status !== 200) {
          throw new Error(`Failed to fetch user info due to en error - "${response.data.error}".`);
        }

        commit('setUserId', response.data.sub);
        return response;
      });
    },
  },
};

export default user;
